import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const LatestInspirarationAPI = () => {
  return axios.get(
    `${env.HOST}/inspirasi-terkini/artikel`,
    {
      headers
    }
  );
};
export default LatestInspirarationAPI;
